import { configureStore, createSlice } from '@reduxjs/toolkit';

import { getSession, saveSession } from './local-storage-adapter';

// Load initial state from localStorage
const persistedSession = getSession();
console.log('persistedSession structure:', persistedSession);
const persistedAuthState = persistedSession?.appState?.auth;

const initialAuthState = {
  accessToken: persistedAuthState?.accessToken || null,
  refreshToken: persistedAuthState?.refreshToken || null,
  isAuthenticated: persistedAuthState?.isAuthenticated || false,
  isImpersonated: persistedAuthState?.isImpersonated || false
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    prelogin: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
      state.isImpersonated = false;
    },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.isImpersonated = false;
    },
    impersonate: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
      state.isImpersonated = true;
    }
  }
});

export const { prelogin, logout, impersonate } = authSlice.actions;

// Middleware to persist state to localStorage
const localStorageMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action);

  // Save the updated state to localStorage after each action
  const state = store.getState();
  saveSession({ appState: state });

  return result;
};

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable check
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }).concat(localStorageMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
